export interface ActivityLog {
    id?: number
    type: ActivityLogType
    action: ActivityLogAction
    datetime: string
    userId: number
    ref: string
}

export enum ActivityLogAction {
    CREATE = "CREATE",
    UPDATE = "UPDATE",
    DELETE = "DELETE",
    ACTIVATED = "ACTIVATED",
    INACTIVATED = "INACTIVATED",
}

export enum ActivityLogType {
    SERVICE_CONTRACT = "SER_CONTRACT",
    PAYABLE_CONTRACT = "PAY_CONTRACT",
    SERVICE_CONTRACT_PAYMENT = "SER_PAYMENT",
    PAYABLE_CONTRACT_PAYMENT = "PAY_PAYMENT",
}

export interface ActivityLogtRecordsFilters {
    ref?: string
    dateFrom?: string
    dateTo?: string
    type?: ActivityLogType
}